import React from "react";
import { MdCheckCircle, MdPending } from 'react-icons/md';
import Card from '../components/UI/Card';

const DownloadA = props => {
    const downloadFile = () => {
      window.location.href = props.url
    }
    return (
              <a type="button" href={props.url} onClick={downloadFile}> {props.nombre} </a> 
    
              

              )
  }
  export default DownloadA;

  /*
                <a type="button" href="https://en.ufm.edu/wp-content/uploads/2022/06/EN-carta-de-recomendacion-ESP.docx" onClick={downloadFile}> Carta de recomendación (español) </a>   
  */